import { FC } from "react";

import { chakra, Flex, Spinner } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { Button } from "@components/buttons";
import Icon from "@components/Icon";
import Message from "@components/Message";

type TSubmitComponentProps = {
  isUpdate?: boolean;
  isSaveSuccess: boolean;
  isLoading: boolean;
  onSubmit: () => void;
};

const SubmitComponent: FC<TSubmitComponentProps> = ({ isUpdate, isSaveSuccess, isLoading, onSubmit }) => {
  const { t } = useTranslation();

  if (isSaveSuccess) {
    const successMessage = isUpdate
      ? t("order-address_changes_successfully_saved")
      : t("order-profile_added_to_address_book");
    return (
      <Message
        variant="success"
        icon={<Icon icon="success" size="1.25rem" />}
        sx={{ fontWeight: 300, height: "3.125rem" }}
      >
        {successMessage}
      </Message>
    );
  }
  if (isLoading) {
    return (
      <Flex justify="center" align="center" width="100%" height="3.125rem">
        <Spinner />
      </Flex>
    );
  }

  const buttonText = isUpdate ? (
    <chakra.span px="1rem">{t("order-save_changes_to_address_book")}</chakra.span>
  ) : (
    t("order-add_profile_to_address_book")
  );

  return (
    <Button
      id="order-new_recipient-save"
      type="button"
      variant={isUpdate ? "grey-light" : "transparent-red"}
      size="lg"
      label={buttonText}
      leftIcon={!isUpdate ? <Icon icon="plus" color="red.lead" size="1.25rem" /> : undefined}
      sx={{
        justifyContent: "start",
        border: "none",
        px: 0,
        whiteSpace: "normal",
        textAlign: "left",
        height: "3.125rem",
        color: "red.lead",
        fontSize: "1rem",
      }}
      onClick={onSubmit}
    />
  );
};
export default SubmitComponent;
